module.exports = __webpack_public_path__ + "img/icon-question-rating-heart-active.6d2e6d3e.svg";